module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/my-home-lockup-cfcb2c62adc9a6dc86cf6eed5d8c423f.svg";